import { render, staticRenderFns } from "./WithholdingEdit.vue?vue&type=template&id=49671ae4&scoped=true"
import script from "./WithholdingEdit.vue?vue&type=script&lang=js"
export * from "./WithholdingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49671ae4",
  null
  
)

export default component.exports